import React, { useEffect, useState } from "react";
import performRequest from "../../api/request";
import LoadingPage from "../../Components/layouts/loading";
import { Toast } from "../../CustomComponent/toast";
import Footer from "../../Components/Footer/footer";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { useSelector } from "react-redux";
import { LeadInfo } from "../../SchemaInfo/info";
import { useNavigate } from "react-router-dom";
import SimpleButton from "../../Components/layouts/simple_button";
import { FcClearFilters } from "react-icons/fc";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import CustomInput from "../../CustomComponent/custom_input";
import CustomSelect from "../../CustomComponent/custom_select";
import {
  LeadAdditionalDetailsInfo,
  LeadAdditionalDetailsSchema,
} from "../../Schemas/sales/leads_additional_details_schema";
import { ErrorMessage, Field, Form, Formik } from "formik";
import {
  setCurrentPage,
  setReduxFilters,
} from "../../redux/Filtered leads/leadCloserReducer";
import { useDispatch } from "react-redux";
function formatSecondsToHMS(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
}
const LeadsCloserFunnelSystem = () => {
  const closerReducer = useSelector((state) => state.leadsCloserReducer);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [leadOwner, setLeadOwner] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [modalData, setModalData] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    leadOwner: "",
    name: "",
  });
  const [collapsedColumns, setCollapsedColumns] = useState(
    closerReducer.collapsedColumns || {}
  );
  const [callTrackingToday, setCallTrackingToday] = useState();
  const role = useSelector((state) => state.login.user.Role);
  const store = useSelector((store) => store.login.user);

  const [openFollowup, setOpenFollowup] = useState(null);
  const [isDropdown, setIsDropdown] = useState("");
  const [isSiDropdown, setIsSiDropdown] = useState("");
  const [pages, setPages] = useState({
    pendingFlw: 1,
    allLeads: 1,
    quotationSent: 1,
    softwareDemo: 1,
    siteInspection: 1,
    bankLoan: 1,
    subsidyDocuments: 1,
    workOrder: 1,
    projectStarted: 1,
    lostLeads: 1,
    todaysFlw: 1,
    page_dprExplain: 1,
  });

  const handleInputChange = (e, props) => {
    let { value } = e.target;
    if (value && value.length >= 4) {
      performRequest("GET", `/quotations/getQuotationsById/${value}`)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.error) {
              setIsDropdown("Quotations Not Found");
              props.setFieldValue("quotationNumber", "");
            } else {
              setIsDropdown(res.data.quotationNumber);
            }
          } else {
            Toast("error", "Error while getting Quotations!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
      setIsDropdown("");
    }
  };
  const handleSiInputChange = (e, props) => {
    let { value } = e.target;
    if (value && value.length === 4) {
      performRequest("GET", `/siteInspection/getSiteInspectionById/${value}`)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.error) {
              setIsSiDropdown("Quotations Not Found");
              props.setFieldValue("siteInspectionId", "");
            } else {
              setIsSiDropdown(res.data.siNumber);
            }
          } else {
            Toast("error", "Error while getting Quotations!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
      setIsSiDropdown("");
    }
  };
  const toggleFollowup = (id) => {
    setOpenFollowup(openFollowup === id ? null : id);
  };

  useEffect(() => {
    performRequest("GET", "/leads/getSalesEmployeeList/")
      .then((res) => {
        setLeadOwner(res.data);
      })
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    if (pages) {
      const query = new URLSearchParams({
        ...filters,
        page_pendingFlw: pages.pendingFlw,
        page_allLeads: pages.allLeads,
        page_quotationSent: pages.quotationSent,
        page_softwareDemo: pages.softwareDemo,
        page_siteInspection: pages.siteInspection,
        page_bankLoan: pages.bankLoan,
        page_subsidyDocuments: pages.subsidyDocuments,
        page_workOrder: pages.workOrder,
        page_projectStarted: pages.projectStarted,
        page_lostLeads: pages.lostLeads,
        page_todaysFlw: pages.todaysFlw,
        page_dprExplain: pages.page_dprExplain,
      }).toString();
      setLoading(true);

      performRequest(
        "GET",
        getFilteredURL(`/leads_v2/get_closer_leads?${query}`)
      )
        .then((res) => {
          if (res.status === 200) {
            setData(res?.data);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [refresh, pages]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(`/callTracking/getAllCallTracking`, 1, {
        leadowner:
          role === process.env.REACT_APP_ROLE_ADMIN_S ||
          role === process.env.REACT_APP_ROLE_HR
            ? userEmail
            : store?.Email,
        startdate: new Date().toISOString().split("T")?.[0],
        enddate: "",
      })
    )
      .then((res) => {
        if (res.status === 200) {
          setCallTrackingToday(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, [store, refresh]);

  const toggleColumn = (status) => {
    setCollapsedColumns((prev) => ({
      ...prev,
      [status]: !prev[status],
    }));
    dispatch(
      setReduxFilters({
        ...collapsedColumns,
        [status]: !collapsedColumns[status],
      })
    );
  };
  if (loading) return <LoadingPage />;

  const getName = (lead) => {
    if (lead.fullName) {
      return lead.fullName;
    }
    if (lead.firstName && lead.lastName) {
      return `${lead.firstName} ${lead.lastName}`;
    }
    if (lead.firstName) {
      return lead.firstName;
    }
    if (lead.lastName) {
      return lead.lastName;
    }
    return "N/A";
  };

  const handleCall = (phoneNumber) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      alert("Phone number is not available!");
    }
  };

  const AddAndAssignLead = (values) => {
    const lead = {
      ...LeadInfo,
      first_name: values?.firstName || values?.fullName || "",
      last_name: values?.lastName || "",
      full_name: getName(values),
      interestedIn: [],
      services: "",
      planned_area: "",
      location_type: "",
      company_name: values?.businessName || "",
      lead_genrated_from: "enquiry",
      lead_alloted_to: store?.Name || "",
      reAssignTo: store?.Name || "",
      preferred_contact_method: "",
      contact_number: values?.mobileNumber || values?.whatsappNumber || "",
      lead_status: "",
      email: values?.email || "",
      gst_number: values?.gst_number || "",
      address: values?.address1 || values?.address2 || "",
      notes: values?.notes || "",
      origin: values?.origin,
    };

    navigate("/leads/add-new-lead", { state: lead });
  };

  const statuses = [
    "Pending Followups",
    "Todays Followups",
    "All Leads",
    "Quotation Sent",
    "Software Demo",
    "Site Inspection",
    "DPR Explanation",
    "Bank Loan",
    "Subsidy Documents",
    "Work Order",
    "Project Started",
    "Lost Lead",
  ];

  const getLeadsCountByStatus = (status) => {
    if (status === "Quotation Sent") {
      return data?.quotationSentCount;
    } else if (status === "All Leads") {
      return data?.allLeadsCount;
    } else if (status === "Software Demo") {
      return data?.softwareDemoCount;
    } else if (status === "Site Inspection") {
      return data?.siteInspectionCount;
    } else if (status === "DPR Explanation") {
      return data?.dprExplainCount;
    } else if (status === "Bank Loan") {
      return data?.bankLoanCount;
    } else if (status === "Subsidy Documents") {
      return data?.subsidyDocumentsCount;
    } else if (status === "Work Order") {
      return data?.workOrderCount;
    } else if (status === "Project Started") {
      return data?.projectStartedCount;
    } else if (status === "Lost Lead") {
      return data?.lostLeadsCount;
    } else if (status === "Pending Followups") {
      return data?.pendingFlwCount;
    } else if (status === "Todays Followups") {
      return data?.todaysFlwCount;
    }
  };

  // ✅ DRAG END HANDLER
  const handleDragEnd = async (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) return;

    const sourceStatus = source.droppableId;
    const destStatus = destination.droppableId;

    if (statuses.indexOf(sourceStatus) >= statuses.indexOf(destStatus)) return;
    const lead = data?.leads?.find(
      (item) => item.id.toString() === draggableId
    );

    if (destStatus == "Software Demo" && !lead?.quotationNumber) {
      Toast(
        "error",
        "Fill all necessary details to move forward with lead tracking"
      );
      return;
    }
    if (
      destStatus == "Site Inspection" &&
      !lead?.quotationNumber
      // || !lead?.softwareDemoScreenshot
    ) {
      Toast(
        "error",
        "Fill all necessary details to move forward with lead tracking"
      );
      return;
    }
    if (
      destStatus == "Bank Loan" &&
      (!lead?.quotationNumber ||
        // !lead?.softwareDemoScreenshot ||
        !lead?.siteInspectionId)
    ) {
      Toast(
        "error",
        "Fill all necessary details to move forward with lead tracking"
      );
      return;
    }
    if (
      destStatus == "Subsidy Documents" &&
      (!lead?.quotationNumber ||
        // !lead?.softwareDemoScreenshot ||
        !lead?.siteInspectionId)
      // ||
      // !lead?.bankLoanStatus ||
      // !lead?.bankLoanDocument
    ) {
      Toast(
        "error",
        "Fill all necessary details to move forward with lead tracking"
      );
      return;
    }
    if (
      destStatus == "Work Order" &&
      (!lead?.quotationNumber ||
        // !lead?.softwareDemoScreenshot ||
        !lead?.siteInspectionId)
      // ||
      // !lead?.bankLoanStatus ||
      // !lead?.bankLoanDocument ||
      // !lead?.subsidyStatus ||
      // !lead?.subsidyDocumentId
    ) {
      Toast(
        "error",
        "Fill all necessary details to move forward with lead tracking"
      );
      return;
    }
    if (
      destStatus == "Project Started" &&
      (!lead?.quotationNumber ||
        // !lead?.softwareDemoScreenshot ||
        !lead?.siteInspectionId ||
        // !lead?.bankLoanStatus ||
        // !lead?.bankLoanDocument ||
        // !lead?.subsidyStatus ||
        // !lead?.subsidyDocumentId ||
        !lead?.workOrder)
    ) {
      Toast(
        "error",
        "Fill all necessary details to move forward with lead tracking"
      );
      return;
    }

    try {
      let res = await performRequest(
        "PATCH",
        `/leads_v2/update_leads/${draggableId}`,
        {
          closer_status: destStatus,
        }
      );

      if (res.status === 200) {
        // Toast("success", "Lead moved successfully");
      }
      setRefresh((prev) => !prev);
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  const handelUpdate = (values, actions) => {
    const formData = new FormData();
    for (let key in values) {
      if (values[key]) formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };

    performRequest(
      "PATCH",
      `/leads_v2/update_leads_add_details/${values.id}`,
      formData
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Leads deatails updated successfully!");
          document.getElementById(`close-model-${values.id}`).click();
          setRefresh((prev) => !prev);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setButtonDisabled(false));
  };

  const statusKeyMap = {
    "Pending Followups": "pendingFlw",
    "All Leads": "allLeads",
    "Quotation Sent": "quotationSent",
    "Software Demo": "softwareDemo",
    "Site Inspection": "siteInspection",
    "Bank Loan": "bankLoan",
    "Subsidy Documents": "subsidyDocuments",
    "Work Order": "workOrder",
    "Project Started": "projectStarted",
    "Lost Lead": "lostLeads",
    "Todays Followups": "todaysFlw",
    "DPR Explanation": "dprExplain",
  };

  const handleNext = (key) => {
    setPages((prev) => ({
      ...prev,
      [key]: prev[key] + 1,
    }));
  };

  const handlePrev = (key) => {
    setPages((prev) => ({
      ...prev,
      [key]: Math.max(prev[key] - 1, 1),
    }));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="card shadow-sm p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h2 className="ms-2 mb-0 fw-bold">Leads Closer Funnel</h2>

            <div className="dropdown">
              <button className="btn btn-primary" data-bs-toggle="dropdown">
                <FcClearFilters size={18} />{" "}
                <span className="ms-1">Apply Filters</span>
              </button>

              <div
                className="dropdown-menu dropdown-menu-end p-3"
                style={{ minWidth: "250px" }}
              >
                <DynamicFilterInput
                  label="Start date"
                  value={filters.startdate}
                  onChange={(e) =>
                    setFilters({ ...filters, startdate: e.target.value })
                  }
                  type="date"
                />

                <DynamicFilterInput
                  label="End date"
                  value={filters.enddate}
                  onChange={(e) =>
                    setFilters({ ...filters, enddate: e.target.value })
                  }
                  type="date"
                />

                <DynamicFilterInput
                  label="Name / Mobile"
                  value={filters.name}
                  onChange={(e) =>
                    setFilters({ ...filters, name: e.target.value })
                  }
                  type="text"
                  placeholder="Search name/mobile"
                />

                {(role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  role === process.env.REACT_APP_ROLE_ADMIN ||
                  role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                  role === process.env.REACT_APP_ROLE_HR) && (
                  <DynamicFilterSelect
                    label="Lead Owner"
                    value={filters.leadOwner}
                    onChange={(e) => {
                      let email = "";
                      leadOwner.filter((el) => {
                        if (el.id == e.target.value) {
                          email = el.email;
                        }
                      });
                      setUserEmail(email);
                      setFilters({ ...filters, leadOwner: e.target.value });
                    }}
                  >
                    <option value="">All</option>
                    {leadOwner?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.userName}
                      </option>
                    ))}
                  </DynamicFilterSelect>
                )}

                <div className="d-flex gap-2 mt-2">
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => setRefresh(!refresh)}
                  >
                    Search
                  </button>

                  <button
                    className="btn btn-secondary w-100"
                    onClick={() => {
                      setUserEmail("");
                      setFilters({
                        startdate: "",
                        enddate: "",
                        leadOwner: "",
                        name: "",
                      });
                      setRefresh(!refresh);
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* STATS */}
          <div className="row g-2">
            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Total Calls</small>
                <div className="fw-bold">
                  {callTrackingToday?.CallRecordCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Attempted</small>
                <div className="fw-bold">
                  {callTrackingToday?.attemptedCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Incoming</small>
                <div className="fw-bold">{callTrackingToday?.inboundCount}</div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Outgoing</small>
                <div className="fw-bold">
                  {callTrackingToday?.outboundCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Answered</small>
                <div className="fw-bold">
                  {callTrackingToday?.answeredCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Unanswered</small>
                <div className="fw-bold">
                  {callTrackingToday?.unAnsweredCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Duration</small>
                <div className="fw-bold">
                  {formatSecondsToHMS(callTrackingToday?.totalDuration)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body mt-1" style={{ minHeight: "90vh" }}>
          <DragDropContext onDragEnd={handleDragEnd}>
            <div className="card" style={{ minHeight: "90vh" }}>
              <div
                className="card-body"
                style={{ display: "flex", overflowX: "auto", gap: "1rem" }}
              >
                {statuses?.map((status, index) => {
                  const leadsCountByStatus = getLeadsCountByStatus(status);
                  const currentKey = statusKeyMap[status];
                  const currentData = data?.[currentKey] || {};
                  const leadsByStatus = currentData.data || [];

                  if (
                    status === "Pending Followups" ||
                    status === "Todays Followups"
                  ) {
                    return (
                      <>
                        <div
                          key={index}
                          className="listName flex-column"
                          style={{
                            padding: "0.5rem",
                            border: "1px solid #c4c4c4",
                            borderRadius: "0.2em",
                            minWidth: "21em",
                            maxHeight: "80vh",
                            overflowY: "auto",
                          }}
                        >
                          <h3
                            style={{
                              margin: "0",
                              padding: "0.5em",
                              background: "#000",
                              color: "#fff",
                              textAlign: "center",
                            }}
                          >
                            {status.toUpperCase()} ({leadsCountByStatus})
                          </h3>

                          <div style={{ marginTop: "0.5rem" }}>
                            {leadsByStatus?.map((lead) => (
                              <div
                                key={lead.id}
                                className={`card p-2 mb-2 ${
                                  status === "Pending Followups"
                                    ? "bg-red-lt"
                                    : "bg-green-lt"
                                }`}
                              >
                                {/* <div
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                  }}
                                >
                                  <strong>Score :</strong>{" "}
                                  {lead?.leadScore || "N/A"}
                                </div> */}
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                  }}
                                >
                                  <strong>Full Name:</strong>{" "}
                                  {lead?.full_name?.toUpperCase() || "N/A"}
                                </div>
                                <div>
                                  <strong>Contact Num:</strong>{" "}
                                  {lead?.contact_number || "N/A"}
                                </div>
                                <div>
                                  <strong>Learning:</strong>{" "}
                                  {lead?.interested_in?.join(", ") || "N/A"}
                                </div>

                                {/* <div>
                      <strong>Email:</strong> {lead?.email || "N/A"}
                    </div>
                    <div>
                      <strong>Enquiry related to:</strong>{" "}
                      {lead?.enquiry_related_to || "N/A"} 
                    </div> */}
                                <div>
                                  <strong>Lead custodian:</strong>{" "}
                                  {lead?.closerDetails?.userName || "N/A"}
                                </div>
                                {/* <div>
                                  <strong>Executive:</strong>{" "}
                                  {lead?.assignedTo?.userName || "N/A"}
                                </div> */}
                                {/* FOLLOWUP BUTTON */}
                                <div
                                  style={{
                                    marginTop: "2px",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    color: "#2c6e49",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                  onClick={() =>
                                    toggleFollowup(lead.id + "abc")
                                  }
                                >
                                  <div>Follow Up</div>
                                  <div>
                                    {openFollowup === lead.id ? "▲" : "▼"}
                                  </div>
                                </div>
                                {/* FOLLOWUP DETAILS */}
                                {openFollowup === lead.id + "abc" && (
                                  <div
                                    style={{
                                      marginTop: "8px",
                                      background: "#ffffff",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      fontSize: "13px",
                                    }}
                                  >
                                    {lead?.followUp?.map((item, index) => (
                                      <div
                                        key={item?.id || index}
                                        style={{ marginBottom: "6px" }}
                                      >
                                        <div>
                                          <strong>Followup Date:</strong>{" "}
                                          {item?.followUpDate || "N/A"}
                                        </div>

                                        <div>
                                          <strong>Followup Message:</strong>{" "}
                                          {item?.followUp || "No Message"}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                <button
                                  className="btn btn-sm px-3 btn-primary mt-2"
                                  onClick={() => {
                                    navigate(
                                      `/leads/edit-new-lead/${lead?.id}?status=closer`
                                    );
                                  }}
                                >
                                  Edit
                                </button>
                              </div>
                            ))}
                          </div>
                          {currentData?.data?.length > 0 && (
                            <hr className="m-0 p-0"></hr>
                          )}
                          {currentData && currentData?.data?.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-2">
                              {/* 🔙 PREV BUTTON */}
                              {currentData.page > 1 ? (
                                <button
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={() => handlePrev(currentKey)}
                                >
                                  Prev
                                </button>
                              ) : (
                                <div>
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => handlePrev(currentKey)}
                                    disabled
                                  >
                                    Prev
                                  </button>
                                </div>
                              )}

                              {/* PAGE INFO */}
                              {
                                <small>
                                  Page {currentData.page} /{" "}
                                  {currentData.totalPages}
                                </small>
                              }

                              {/* 🔜 NEXT BUTTON */}
                              {currentData.page < currentData.totalPages ? (
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => handleNext(currentKey)}
                                >
                                  Next
                                </button>
                              ) : (
                                <div>
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    disabled
                                    onClick={() => handleNext(currentKey)}
                                  >
                                    Next
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <Droppable droppableId={status} key={status}>
                        {(provided) => (
                          <>
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              className="listName flex-column"
                              style={{
                                padding: "0.5rem",
                                border: "1px solid #c4c4c4",
                                borderRadius: "0.2em",
                                minWidth: collapsedColumns[status]
                                  ? "60px"
                                  : "21em",
                                transition: "0.3s ease",
                                maxHeight: "80vh",
                                overflowY: "auto",
                              }}
                            >
                              <h3
                                style={{
                                  margin: "0",
                                  padding: "0.5em",
                                  background: "#000",
                                  color: "#fff",
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => toggleColumn(status)}
                              >
                                {collapsedColumns[status]
                                  ? "▶"
                                  : `${status.toUpperCase()} (${leadsCountByStatus})`}
                              </h3>

                              <div style={{ marginTop: "0.5rem" }}>
                                {!collapsedColumns[status] &&
                                  leadsByStatus?.map((lead, leadIndex) => (
                                    <Draggable
                                      // isDragDisabled={true}
                                      key={lead.id}
                                      draggableId={lead.id.toString()}
                                      index={leadIndex}
                                    >
                                      {(provided) => (
                                        <div
                                          key={lead.id}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          className={`card p-2 mb-2 ${
                                            status === "Pending Followups"
                                              ? "bg-red-lt"
                                              : status === "All Leads"
                                              ? "bg-yellow-lt"
                                              : status === "Lost Lead"
                                              ? "bg-orange-lt"
                                              : "bg-lime-lt"
                                          }`}
                                        >
                                          {/* <div
                                          style={{
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                          }}
                                        >
                                          <strong>Score :</strong>{" "}
                                          {lead?.leadScore || "N/A"}
                                        </div> */}
                                          <div
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "14px",
                                            }}
                                          >
                                            <strong>Full Name:</strong>{" "}
                                            {lead?.full_name?.toUpperCase() ||
                                              "N/A"}
                                          </div>
                                          <div>
                                            <strong>Contact Num:</strong>{" "}
                                            {lead?.contact_number || "N/A"}
                                          </div>
                                          <div>
                                            <strong>Learning:</strong>{" "}
                                            {lead?.interested_in?.join(", ") ||
                                              "N/A"}
                                          </div>

                                          {/* <div>
                              <strong>Email:</strong> {lead?.email || "N/A"}
                            </div>
                            <div>
                              <strong>Enquiry related to:</strong>{" "}
                              {lead?.enquiry_related_to || "N/A"} 
                            </div> */}
                                          <div>
                                            <strong>Lead custodian:</strong>{" "}
                                            {lead?.closerDetails?.userName ||
                                              "N/A"}
                                          </div>
                                          {/* <div>
                                            <strong>Executive:</strong>{" "}
                                            {lead?.assignedTo?.userName ||
                                              "N/A"}
                                          </div> */}

                                          {/* FOLLOWUP BUTTON */}
                                          <div
                                            style={{
                                              marginTop: "2px",
                                              cursor: "pointer",
                                              fontWeight: "600",
                                              color: "#2c6e49",
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                            onClick={() =>
                                              toggleFollowup(lead.id)
                                            }
                                          >
                                            <div>Follow Up</div>
                                            <div>
                                              {openFollowup === lead.id
                                                ? "▲"
                                                : "▼"}
                                            </div>
                                          </div>
                                          {/* FOLLOWUP DETAILS */}
                                          {openFollowup === lead.id && (
                                            <div
                                              style={{
                                                marginTop: "8px",
                                                background: "#ffffff",
                                                padding: "8px",
                                                borderRadius: "4px",
                                                fontSize: "13px",
                                              }}
                                            >
                                              {lead?.followUp?.map(
                                                (item, index) => (
                                                  <div
                                                    key={item?.id || index}
                                                    style={{
                                                      marginBottom: "6px",
                                                    }}
                                                  >
                                                    <div>
                                                      <strong>
                                                        Followup Date:
                                                      </strong>{" "}
                                                      {item?.followUpDate ||
                                                        "N/A"}
                                                    </div>

                                                    <div>
                                                      <strong>
                                                        Followup Message:
                                                      </strong>{" "}
                                                      {item?.followUp ||
                                                        "No Message"}
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          )}

                                          <div className="row gap-2 px-2">
                                            {status !== "All Leads" && (
                                              <button
                                                className="col btn btn-sm px-3 btn-primary mt-2"
                                                data-bs-toggle="modal"
                                                data-bs-target={`#modal-team-${lead.id}`}
                                              >
                                                Status Details
                                              </button>
                                            )}
                                            <button
                                              className="col  btn btn-sm px-3 btn-primary mt-2"
                                              onClick={() => {
                                                navigate(
                                                  `/leads/edit-new-lead/${lead?.id}?status=closer`
                                                );
                                              }}
                                            >
                                              Edit
                                            </button>
                                          </div>

                                          <div
                                            className="modal modal-blur fade"
                                            id={`modal-team-${lead.id}`}
                                            tabIndex="-1"
                                            role="dialog"
                                            aria-hidden="true"
                                          >
                                            <Formik
                                              initialValues={{
                                                ...LeadAdditionalDetailsInfo,
                                                quotationNumber:
                                                  lead?.quotationNumber || "",
                                                softwareDemoScreenshot:
                                                  lead?.softwareDemoScreenshot ||
                                                  "",
                                                siteInspectionId:
                                                  lead?.siteInspectionId || "",
                                                bankLoanStatus:
                                                  lead?.bankLoanStatus || "",
                                                bankLoanDocument:
                                                  lead?.bankLoanDocument || "",
                                                subsidyStatus:
                                                  lead?.subsidyStatus || "",
                                                subsidyDocumentId:
                                                  lead?.subsidyDocumentId || "",
                                                workOrder:
                                                  lead?.workOrder || "",
                                                projectTrackingId:
                                                  lead?.projectTrackingId || "",
                                              }}
                                              validationSchema={
                                                LeadAdditionalDetailsSchema
                                              }
                                              onSubmit={(values) => {
                                                setButtonDisabled(true);
                                                handelUpdate({
                                                  ...values,
                                                  id: lead?.id,
                                                });
                                              }}
                                            >
                                              {(props) => (
                                                <Form className="modal-dialog modal-dialog-centered w-100">
                                                  <div className="modal-content">
                                                    <div className="modal-header">
                                                      <h5 className="modal-title">
                                                        Leads additional details
                                                      </h5>
                                                      <button
                                                        type="button"
                                                        className="btn-close"
                                                        data-bs-dismiss="modal"
                                                      ></button>
                                                    </div>
                                                    <div className="modal-body">
                                                      {/* Quotation Number */}
                                                      <div className="mb-3 dropdown">
                                                        <label className="form-label required">
                                                          Quotation Number
                                                        </label>
                                                        <Field
                                                          name="quotationNumber"
                                                          className="form-control"
                                                          onChange={(e) => {
                                                            props.setFieldValue(
                                                              "quotationNumber",
                                                              e.target.value
                                                            );
                                                            handleInputChange(
                                                              e,
                                                              props
                                                            );
                                                          }}
                                                        />
                                                        <ErrorMessage
                                                          name="quotationNumber"
                                                          component="p"
                                                          className="text-danger"
                                                        />

                                                        {props.touched
                                                          .quotationNumber &&
                                                          props.errors
                                                            .quotationNumber && (
                                                            <p className="text-danger">
                                                              {
                                                                props.errors
                                                                  .quotationNumber
                                                              }
                                                            </p>
                                                          )}
                                                        {isDropdown && (
                                                          <span
                                                            onClick={() => {
                                                              if (
                                                                isDropdown !==
                                                                  "Quotations Not Found" &&
                                                                isDropdown !==
                                                                  ""
                                                              ) {
                                                                props.setFieldValue(
                                                                  "quotationNumber",
                                                                  isDropdown
                                                                );
                                                                setIsDropdown(
                                                                  ""
                                                                );
                                                              }
                                                            }}
                                                            className="card cursor-pointer px-2 py-1 m-2"
                                                          >
                                                            {isDropdown}
                                                          </span>
                                                        )}
                                                      </div>
                                                      {/* Software Demo Screenshot */}{" "}
                                                      {status !=
                                                        "Quotation Sent" && (
                                                        <>
                                                          <div className="mb-3">
                                                            <label className="form-label">
                                                              Software demo
                                                              screenshot
                                                            </label>
                                                            {lead?.softwareDemoScreenshot && (
                                                              <div className="px-2 pb-2">
                                                                <a
                                                                  target="_blank"
                                                                  href={
                                                                    lead?.softwareDemoScreenshot
                                                                  }
                                                                >
                                                                  {
                                                                    lead?.softwareDemoScreenshot
                                                                  }
                                                                </a>
                                                              </div>
                                                            )}
                                                            <input
                                                              type="file"
                                                              className="form-control"
                                                              onChange={(e) =>
                                                                props.setFieldValue(
                                                                  "softwareDemoScreenshot",
                                                                  e.target
                                                                    .files[0]
                                                                )
                                                              }
                                                            />
                                                            <ErrorMessage
                                                              name="softwareDemoScreenshot"
                                                              component="p"
                                                              className="text-danger"
                                                            />
                                                          </div>
                                                          {/* Site Inspection ID */}
                                                          {status !=
                                                            "Software Demo" && (
                                                            <>
                                                              <div className="mb-3 dropdown">
                                                                <label className="form-label required">
                                                                  Site
                                                                  inspection id
                                                                </label>
                                                                <Field
                                                                  name="siteInspectionId"
                                                                  className="form-control"
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    props.setFieldValue(
                                                                      "siteInspectionId",
                                                                      e.target
                                                                        .value
                                                                    );
                                                                    handleSiInputChange(
                                                                      e,
                                                                      props
                                                                    );
                                                                  }}
                                                                />
                                                                <ErrorMessage
                                                                  name="siteInspectionId"
                                                                  component="p"
                                                                  className="text-danger"
                                                                />

                                                                {props.touched
                                                                  .siteInspectionId &&
                                                                  props.errors 
                                                                    .siteInspectionId && (
                                                                    <p className="text-danger">
                                                                      {
                                                                        props
                                                                          .errors
                                                                          .siteInspectionId
                                                                      }
                                                                    </p>
                                                                  )}
                                                                {isSiDropdown && (
                                                                  <span
                                                                    onClick={() => {
                                                                      if (
                                                                        isSiDropdown !==
                                                                          "Site Inspection Id Not Found" &&
                                                                        isSiDropdown !==
                                                                          ""
                                                                      ) {
                                                                        props.setFieldValue(
                                                                          "siteInspectionId",
                                                                          isSiDropdown
                                                                        );
                                                                        setIsSiDropdown(
                                                                          ""
                                                                        );
                                                                      }
                                                                    }}
                                                                    className="card cursor-pointer px-2 py-1 m-2"
                                                                  >
                                                                    {
                                                                      isSiDropdown
                                                                    }
                                                                  </span>
                                                                )}
                                                              </div>
                                                              {/* Bank Loan Status */}
                                                              {status !=
                                                                "Site Inspection" && (
                                                                <>
                                                                  <div className="mb-3">
                                                                    <label className="form-label">
                                                                      Bank loan
                                                                      status
                                                                    </label>
                                                                    <Field
                                                                      as="select"
                                                                      name="bankLoanStatus"
                                                                      className="form-control"
                                                                    >
                                                                      <option value="">
                                                                        Select
                                                                      </option>
                                                                      <option value="pending">
                                                                        Pending
                                                                      </option>
                                                                      <option value="approved">
                                                                        Approved
                                                                      </option>
                                                                      <option value="rejected">
                                                                        Rejected
                                                                      </option>
                                                                    </Field>
                                                                    <ErrorMessage
                                                                      name="bankLoanStatus"
                                                                      component="p"
                                                                      className="text-danger"
                                                                    />
                                                                  </div>
                                                                  {/* Bank Loan Document */}
                                                                  {status !=
                                                                    "Site Inspection" && (
                                                                    <>
                                                                      <div className="mb-3">
                                                                        <label className="form-label">
                                                                          Bank
                                                                          loan
                                                                          document
                                                                        </label>
                                                                        {lead?.bankLoanDocument && (
                                                                          <div className="px-2 pb-2">
                                                                            <a
                                                                              target="_blank"
                                                                              href={
                                                                                lead?.bankLoanDocument
                                                                              }
                                                                            >
                                                                              {
                                                                                lead?.bankLoanDocument
                                                                              }
                                                                            </a>
                                                                          </div>
                                                                        )}
                                                                        <input
                                                                          type="file"
                                                                          className="form-control"
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            props.setFieldValue(
                                                                              "bankLoanDocument",
                                                                              e
                                                                                .target
                                                                                .files[0]
                                                                            )
                                                                          }
                                                                        />
                                                                        <ErrorMessage
                                                                          name="bankLoanDocument"
                                                                          component="p"
                                                                          className="text-danger"
                                                                        />
                                                                      </div>
                                                                      {/* Subsidy Status */}
                                                                      {status !=
                                                                        "Bank Loan" && (
                                                                        <>
                                                                          <div className="mb-3">
                                                                            <label className="form-label">
                                                                              Subsidy
                                                                              status
                                                                            </label>
                                                                            <Field
                                                                              as="select"
                                                                              name="subsidyStatus"
                                                                              className="form-control"
                                                                            >
                                                                              <option value="">
                                                                                Select
                                                                              </option>
                                                                              <option value="not_applied">
                                                                                Not
                                                                                Applied
                                                                              </option>
                                                                              <option value="applied">
                                                                                Applied
                                                                              </option>
                                                                              <option value="approved">
                                                                                Approved
                                                                              </option>
                                                                            </Field>
                                                                            <ErrorMessage
                                                                              name="subsidyStatus"
                                                                              component="p"
                                                                              className="text-danger"
                                                                            />
                                                                          </div>
                                                                          {/* Subsidy Document ID */}

                                                                          <div className="mb-3">
                                                                            <label className="form-label">
                                                                              Subsidy
                                                                              document
                                                                              ID
                                                                            </label>
                                                                            <Field
                                                                              name="subsidyDocumentId"
                                                                              className="form-control"
                                                                            />
                                                                            <ErrorMessage
                                                                              name="subsidyDocumentId"
                                                                              component="p"
                                                                              className="text-danger"
                                                                            />
                                                                          </div>
                                                                          {/* Work Order */}
                                                                          {status !=
                                                                            "Subsidy Documents" && (
                                                                            <>
                                                                              <div className="mb-3">
                                                                                <label className="form-label required">
                                                                                  Work
                                                                                  order
                                                                                </label>
                                                                                {lead?.workOrder && (
                                                                                  <div className="px-2 pb-2">
                                                                                    <a
                                                                                      target="_blank"
                                                                                      href={
                                                                                        lead?.workOrder
                                                                                      }
                                                                                    >
                                                                                      {
                                                                                        lead?.workOrder
                                                                                      }
                                                                                    </a>
                                                                                  </div>
                                                                                )}
                                                                                <input
                                                                                  type="file"
                                                                                  className="form-control"
                                                                                  onChange={(
                                                                                    e
                                                                                  ) =>
                                                                                    props.setFieldValue(
                                                                                      "workOrder",
                                                                                      e
                                                                                        .target
                                                                                        .files[0]
                                                                                    )
                                                                                  }
                                                                                />
                                                                                <ErrorMessage
                                                                                  name="workOrder"
                                                                                  component="p"
                                                                                  className="text-danger"
                                                                                />
                                                                              </div>
                                                                              {/* Project Tracking ID */}
                                                                              {status !=
                                                                                "Work Order" && (
                                                                                <>
                                                                                  <div className="mb-3">
                                                                                    <label className="form-label required">
                                                                                      Project
                                                                                      tracking
                                                                                      id
                                                                                    </label>
                                                                                    <Field
                                                                                      name="projectTrackingId"
                                                                                      className="form-control"
                                                                                    />
                                                                                    <ErrorMessage
                                                                                      name="projectTrackingId"
                                                                                      component="p"
                                                                                      className="text-danger"
                                                                                    />
                                                                                  </div>
                                                                                </>
                                                                              )}
                                                                            </>
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    </>
                                                                  )}
                                                                </>
                                                              )}
                                                            </>
                                                          )}
                                                        </>
                                                      )}
                                                    </div>

                                                    <div className="modal-footer">
                                                      <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        data-bs-dismiss="modal"
                                                        id={`close-model-${lead?.id}`}
                                                      >
                                                        Close
                                                      </button>

                                                      <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        disabled={
                                                          buttonDisabled
                                                        }
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </Form>
                                              )}
                                            </Formik>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                              </div>
                              {currentData?.data?.length > 0 && (
                                <hr className="m-0 p-0"></hr>
                              )}
                              {!collapsedColumns[status] &&
                                currentData &&
                                currentData?.data?.length > 0 && (
                                  <div className="d-flex justify-content-between align-items-center mt-2">
                                    {/* 🔙 PREV BUTTON */}
                                    {currentData.page > 1 ? (
                                      <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => handlePrev(currentKey)}
                                      >
                                        Prev
                                      </button>
                                    ) : (
                                      <div>
                                        <button
                                          className="btn btn-sm btn-outline-secondary"
                                          onClick={() => handlePrev(currentKey)}
                                          disabled
                                        >
                                          Prev
                                        </button>
                                      </div>
                                    )}

                                    {/* PAGE INFO */}
                                    {
                                      <small>
                                        Page {currentData.page} /{" "}
                                        {currentData.totalPages}
                                      </small>
                                    }

                                    {/* 🔜 NEXT BUTTON */}
                                    {currentData.page <
                                    currentData.totalPages ? (
                                      <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => handleNext(currentKey)}
                                      >
                                        Next
                                      </button>
                                    ) : (
                                      <div>
                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          disabled
                                          onClick={() => handleNext(currentKey)}
                                        >
                                          Next
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                )}
                            </div>
                          </>
                        )}
                      </Droppable>
                    );
                  }
                })}
              </div>
            </div>
          </DragDropContext>
          <div
            class="modal modal-blur fade"
            id="enquiry-report"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Filter lead</h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  {modalData && (
                    <>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Full name
                        </label>
                        <div className="w-100 col">
                          {(
                            modalData?.fullName ||
                            modalData?.firstName ||
                            "N/A"
                          ).toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">Address</label>
                        <div className="w-100 col">
                          {(
                            modalData.address1 ||
                            modalData.address2 ||
                            "N/A"
                          ).toUpperCase()}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Email Address
                        </label>
                        <div className="w-100 col">
                          {modalData?.email || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Phone Number
                        </label>
                        <div className="w-100 col">
                          {modalData?.mobileNumber ||
                          modalData?.whatsappNumber ? (
                            <span
                              onClick={() =>
                                handleCall(
                                  modalData?.mobileNumber ||
                                    modalData?.whatsappNumber
                                )
                              }
                              className="cursor-pointer text-blue text-decoration-underline"
                            >
                              <svg
                                color="green"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                class="icon icon-tabler icons-tabler-outline icon-tabler-phone-outgoing"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                                <path d="M15 9l5 -5" />
                                <path d="M16 4l4 0l0 4" />
                              </svg>

                              {modalData?.mobileNumber ||
                                modalData?.whatsappNumber}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {/* <div className="mb-3 row d-lg-none d-md-none">
                              <label className="w-25 form-label col-3">Call Now</label>
                              <div className="w-100 col">
                                <SimpleButton buttonText="Call Now" />
                              </div>
                            </div> */}
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Lead Generated From
                        </label>
                        <div className="w-100 col">
                          {(modalData?.origin || "N/A").toUpperCase()}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div class="modal-footer">
                  <div>
                    <SimpleButton
                      buttonText="Not Connected"
                      type="secondary"
                      data-bs-dismiss="modal"
                    />
                  </div>

                  <div class="ms-auto">
                    <SimpleButton
                      onClick={() => AddAndAssignLead(modalData)}
                      buttonText="Call Connected"
                      data-bs-dismiss="modal"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default LeadsCloserFunnelSystem;
